import Stepper from "@/components/Stepper";
import MobileStepDisplay from "@/components/MultiStepForm/MobileStepDisplay";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import { toFormat } from "@/lib/dateHelpers";

interface SessionStepperProps {
  sessionDates: Array<{ startsAt: string }>;
  activeSession: number;
  onSessionChange: (index: number) => void;
}

export default function SessionStepper({ sessionDates, activeSession, onSessionChange }: SessionStepperProps) {
  const { isCompactLayout } = useIsCompactLayout();

  const stepsList = sessionDates.map((session, index) => ({
    headline: toFormat(session.startsAt) ?? "",
    supportingText: `Session ${index + 1}`
  }));

  if (stepsList.length === 0) return null;

  if (isCompactLayout) {
    return (
      <MobileStepDisplay
        steps={stepsList}
        currentStep={activeSession}
        handleStepClick={onSessionChange}
        variant="selection"
        title="Sessions"
      />
    );
  }

  return (
    <Stepper activeIndex={activeSession} onStepClick={onSessionChange} stepsList={stepsList} variant="selection" />
  );
}
